export default "__VITE_PUBLIC_ASSET__f57df7fe__"